export function uncloak(el) {
  el.removeAttribute('data-cloak')
}
